import type { SxProps, Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const drawerPaperSx: SxProps<Theme> = { width: 360, display: 'flex', flexDirection: 'column' };

export const optionBoxSx = (selected: boolean): SxProps<Theme> => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 2,
  p: 2.5,
  borderRadius: 1,
  cursor: 'pointer',
  border: 1,
  borderColor: selected ? 'text.primary' : 'divider',
  outline: selected ? '1px solid' : 'none',
  outlineColor: 'text.primary',
});

export const styles = (theme: Theme) => ({
  iconButtonSx: (openPopover: boolean) => ({
    width: 40,
    height: 40,
    background: alpha(theme.palette.grey[500], 0.08),
    ...(openPopover && {
      background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
    }),
  }),
  avatarSx: {
    width: 36,
    height: 36,
    border: `solid 2px ${theme.palette.background.default}`,
  },
  popOverSx: { p: 0 },
  popOverBoxSx: { my: 1.5, px: 2.5, width: 220 },
  userNameSx: { color: 'text.secondary' },
  launchIconSx: { color: 'text.secondary', marginRight: '0 !important' },
  stackSx: { p: 1 },
  menuItemStackSx: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%' },
  menuItemSx: { m: 1 },
});
